import { render, staticRenderFns } from "./ScannerCard.vue?vue&type=template&id=0ed19691&scoped=true&"
import script from "./ScannerCard.vue?vue&type=script&lang=js&"
export * from "./ScannerCard.vue?vue&type=script&lang=js&"
import style0 from "./ScannerCard.vue?vue&type=style&index=0&id=0ed19691&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed19691",
  null
  
)

export default component.exports